export default __webpack_public_path__ + "static/media/pe.be8fc0ab.png";